import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=41d2d756&scoped=true"
import script from "./AboutNew.vue?vue&type=script&lang=js"
export * from "./AboutNew.vue?vue&type=script&lang=js"
import style0 from "./AboutNew.vue?vue&type=style&index=0&id=41d2d756&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d2d756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d2d756')) {
      api.createRecord('41d2d756', component.options)
    } else {
      api.reload('41d2d756', component.options)
    }
    module.hot.accept("./AboutNew.vue?vue&type=template&id=41d2d756&scoped=true", function () {
      api.rerender('41d2d756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/AboutNew.vue"
export default component.exports